function isProd() {
  return window.location.hostname === 'app.omnicrane.com';
}

function getRAGURL() {
  if (isProd()) {
    return "https://rag.omnicrane.com"
  }
  return "https://rag.stage.omnicrane.com";
}

const requestOptions = {
  method: "GET",
  redirect: "follow",
  headers: {
    'x-api-key': 'Y9IBl9w0owCpyZ5pZ0wCFosvqNbk'
  }
};

export async function fetchContext(organizationId, query) {
  const response = await fetch(`${getRAGURL()}/context?organizationId=${organizationId}&query=${query}`, requestOptions);
  const { content } = await response.json();
  console.log(`[DEBUG] RAG query: ${query},\n response: ${content}`);
  if (!content.startsWith('ERROR:')) {
    return content;
  }
  console.error('[DEBUG] parsed content start with error:', content);
  return '';
}

export async function addToRAG(organizationId, url) {  
  const response = await fetch(`${getRAGURL()}/scraping?organizationId=${organizationId}&url=${url}`, requestOptions);
  const {result} = await response.json();
  console.log(`[DEBUG] RAG scrape: ${url},\n response: ${result}`);
  return result
}

export async function deleteOrganizationDataFromRAG(organizationId) {  
  await fetch(`${getRAGURL()}/delete?organizationId=${organizationId}`, requestOptions);
}